<template>
    <AModal
        :visible="visible"
        title="List Toko"
        @cancel="handleModalCancel"
        :destroy-on-close="true"
        width="70%"
        :footer="null">

        <template v-if="hasRoles([ROLE_ADMIN_BK, ROLE_DISTRIBUTOR, ROLE_TSO, ROLE_TIM_CRM, ROLE_HELPDESK, ROLE_CRM_HELPDESK_CUSTOMER_CARE, ROLE_ASM])">
            <AForm
                v-if="state.isForm"
                ref="formRef"
                class="myform"
                :model="form"
                :rules="state.rules"
                @finish="handleOk"
                :wrapper-col="{ span: 14 }"
                :scroll-to-first-error="true">

                <!-- distributor -->
                <a-row
                    v-if="hasRoles([ROLE_ADMIN_BK, ROLE_TSO, ROLE_TIM_CRM, ROLE_HELPDESK, ROLE_CRM_HELPDESK_CUSTOMER_CARE, ROLE_ASM])"
                    class="form-row">
                    <a-col :sm="24">
                        <a-form-item
                            label="Pilih Distributor"
                            label-align="left"
                            :label-col="{ sm: { span: 4 } }"
                            :wrapper-col="{ sm: { span: 24 - 4 } }"
                            required
                            name="distributor_id"
                            has-feedback>
                            <FilterATSalesmanDistributorSalesman
                                v-model:salesman_id="form.salesman_id"
                                v-model:value="form.distributor_id"
                                style="width:100%;"/>
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- TSO -->
                <a-row
                    v-if="hasRoles([ROLE_DISTRIBUTOR])"
                    class="form-row">
                    <a-col :sm="24">
                        <a-form-item
                            label="Pilih TSO"
                            label-align="left"
                            :label-col="{ sm: { span: 4 } }"
                            :wrapper-col="{ sm: { span: 24 - 4 } }"
                            required
                            name="tso_id"
                            has-feedback>
                                <FilterUserByVendorMapping
                                    style="width:100%"
                                    placeholder="Pilih TSO"
                                    :role_id="55414"
                                    :mode="null"
                                    :disabled="item.readOnly"
                                    v-model:value="form.tso_id"/>
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- toko -->
                <a-row class="form-row">
                    <a-col :sm="24">
                        <a-form-item
                            label="Pilih Toko"
                            label-align="left"
                            :label-col="{ sm: { span: 4 } }"
                            :wrapper-col="{ sm: { span: 24 - 4 } }"
                            required
                            name="customer_id"
                            has-feedback>
                            <FilterATSalesmanCustomer
                                v-model:value="form.customer_id"
                                v-model:tso="form.tso_id"
                                v-model:distributor="form.distributor_id"
                                style="width:100%;"/>
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- submit -->
                <a-row class="form-row mt-2">
                    <ACol :sm="4"/>
                    <a-col :sm="20">
                        <ASpace>
                            <AButton
                                type="primary"
                                html-type="submit"
                                :loading="form.busy"
                                :disabled="form.busy">Simpan</AButton>
                            <AButton
                                title="Batal"
                                @click="state.isForm = !state.isForm; form.reset()">Batal</AButton>
                        </ASpace>
                    </a-col>
                </a-row>
            </AForm>
            <div v-else class="row align-items-center justify-content-between mb-3">
                <!-- KIRI: Filter Toko -->
                <div class="col-md-6 align-items-center gap-2">              
                    <ARow :gutter="[8, 8]">
                      <ACol :sm="10">
                        <FilterSalesmanToko
                          style="width: 100%"
                          v-model:value="state.params.toko"
                          :salesman="form.salesman_id"
                        />
                      </ACol>
                      <ACol :sm="10">
                        <FilterArea
                          style="width: 100%"
                          v-model:value="state.params.area"
                          :toko="form.salesman_id"
                          v-can:hide.distributor
                        />
                      </ACol>
                      <ACol :sm="4">
                        <AButton
                            type="primary"
                            title="Cari"
                            @click="fetchDataList"
                            :loading="state.isFetching">
                            <span v-if="!state.isFetching" class="fa fa-search" aria-hidden="true" />
                            <span v-else>Memuat Data ...</span>
                        </AButton>
                      </ACol>
                    </ARow>
                </div>
                <div class="col-md-auto text-end">
                    <ASpace>
                        <!-- is empties digunakan untuk memvalidasi apakah distributor ada dan toko kosong -->

                        <!-- Switch Mapping Toko -->
                        <ATooltip
                            v-if="hasRoles([ROLE_ADMIN_BK, ROLE_TSO, ROLE_ASM])"
                            title="Switch Mapping Toko">
                            <AButton
                                type="primary"
                                :disabled="!item.active"
                                @click="btnFormSwitchSalesman">
                                <i class="fa fa-retweet" aria-hidden="true" />
                            </AButton>
                        </ATooltip>
                        <!-- Transfer Toko For All Salesman -->
                        <ATooltip
                            v-if="hasRoles([ROLE_ADMIN_BK, ROLE_TSO, ROLE_ASM])"
                            title="Transfer Toko Dari Salesman">
                            <AButton
                                type="primary"
                                :disabled="!item.active"
                                @click="btnFormTransferForAllSalesman">
                                <i class="fa fa-share-square" aria-hidden="true" />
                            </AButton>
                        </ATooltip>
                        <!-- Transfer Toko For New Salesman -->
                        <ATooltip
                            v-if="(!item.is_empty_distributor && item.is_empty_toko) && hasRoles([ROLE_ADMIN_BK, ROLE_TSO, ROLE_ASM])"
                            title="Transfer Toko Dari Salesman">
                            <AButton
                                type="primary"
                                :disabled="!item.active"
                                @click="btnFormTransferSalesman">
                                <i class="fa fa-user-o" aria-hidden="true" />
                            </AButton>
                        </ATooltip>
                        <ATooltip
                            v-if="(!item.is_empty_distributor && item.is_empty_toko) && hasRoles([ROLE_ADMIN_BK, ROLE_TSO, ROLE_ASM])"
                            title="Transfer Toko Dari Salesman">
                            <AButton
                                type="primary"
                                :disabled="!item.active"
                                @click="btnFormTransferSalesman">
                                <i class="fa fa-user-o" aria-hidden="true"/>
                            </AButton>
                        </ATooltip>
                        <ATooltip
                            v-if="hasRoles([ROLE_ADMIN_BK, ROLE_DISTRIBUTOR, ROLE_TSO, ROLE_TIM_CRM, ROLE_HELPDESK, ROLE_CRM_HELPDESK_CUSTOMER_CARE, ROLE_ASM])"
                            title="Upload Dokumen">
                            <AButton
                                type="primary"
                                :disabled="!item.active"
                                @click="btnUpload">
                                <i class="fa fa-upload" aria-hidden="true"></i>
                            </AButton>
                        </ATooltip>
                        <ATooltip
                            v-if="hasRoles([ROLE_ADMIN_BK, ROLE_DISTRIBUTOR, ROLE_TSO, ROLE_TIM_CRM, ROLE_HELPDESK, ROLE_CRM_HELPDESK_CUSTOMER_CARE, ROLE_ASM])"
                            title="Tambahkan">
                            <AButton
                                @click="state.isForm = !state.isForm"
                                :disabled="!item.active"
                                type="primary">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </AButton>
                        </ATooltip>
                        <ATooltip title="Download excel">
                            <DownloadExcel
                                :url="state.endpoint.current"
                                :params="state.params"
                                :disabled="!item.active"
                                namefile="List-Toko-Mapping-Salesman"
                                @errors="errorMessage"/>
                        </ATooltip>
                    </ASpace>
                </div>
            </div>
        </template>

        <AAlert
            v-if="errorMessage"
            type="error"
            :message="errorMessage"
            banner
            closable
            @close="errorMessage = null"/>

        <div v-if="state.errors.length" class="mt-2">
            <AAlert
                v-for="(item, index) in state.errors"
                class="mb-2"
                :type="item.status ? 'success' : 'error'"
                :key="index"
                :message="item.message"
                banner
                closable
                @close="state.errors = []" />
        </div>

        <!-- list table -->
        <div class="table-responsive text-nowrap mt-4">
            <MdTable
                :columns="state.columns"
                :data-source="state.data"
                row-key="id"
                size="small"
                :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                :pagination="{
                    showSizeChanger: true,
                    pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
                    showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} Hasil ${total} `,
                    total: state.meta.total,
                    pageSize: state.meta.per_page,
                    current: state.meta.page,
                }"
                @change="handleTableChange"
                :loading="state.isFetching">
                <template #action="{ record }">
                    <ASpace>
                        <ATooltip
                            v-if="hasRoles([ROLE_ADMIN_BK, ROLE_TSO, ROLE_TIM_CRM, ROLE_HELPDESK, ROLE_CRM_HELPDESK_CUSTOMER_CARE, ROLE_DISTRIBUTOR, ROLE_ASM])"
                            title="Hapus">
                            <AButton
                                class="button"
                                size="small"
                                :loading="record.isDelete"
                                :disabled="record.isDeleteDisabled"
                                @click="btnDelete(record)">
                                <i class="fe fe-trash" />
                            </AButton>
                        </ATooltip>
                    </ASpace>
                </template>
            </MdTable>
        </div>

        <!-- upload -->
        <UploadTokoList
            v-if="visibleUploadModal"
            v-model:visible="visibleUploadModal"
            v-model:item="visibleUploadItemModal"
            @success="fetchDataList"/>

        <!-- form Switch salesman -->
        <SwitchMappingSalesmanActionTokoList
            v-if="visibleFormSwitchSalesmanModal"
            v-model:visible="visibleFormSwitchSalesmanModal"
            v-model:item="visibleFormSwitchSalesmanItemModal"
            @success="fetchDataList"/>

        <!-- form transfer for All salesman -->
        <TransferForAllSalesmanActionTokoList
            v-if="visibleFormTransferForAllSalesmanModal"
            v-model:visible="visibleFormTransferForAllSalesmanModal"
            v-model:item="visibleFormTransferForAllSalesmanItemModal"
            @success="fetchDataList"/>

        <!-- form transfer for new salesman -->
        <TransferSalesmanActionTokoList
            v-if="visibleFormTransferSalesmanModal"
            v-model:visible="visibleFormTransferSalesmanModal"
            v-model:item="visibleFormTransferSalesmanItemModal"
            @success="fetchDataList"/>
    </AModal>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, computed } from 'vue'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import FilterArea from '@/components/filter/FilterAreaSalesman'
import FilterSalesmanToko from '@/components/filter/FilterSalesToko'
import FilterATSalesmanCustomer from '@/components/filter/FilterATSalesmanCustomer'
import FilterATSalesmanDistributorSalesman from '@/components/filter/FilterATSalesmanDistributorSalesman'
import FilterUserByVendorMapping from '@/components/filter/FilterUserByVendorMapping'
import DownloadExcel from '@/components/Molecules/DownloadExcel'
import UploadTokoList from './UploadTokoList'
import SwitchMappingSalesmanActionTokoList from './SwitchMappingSalesmanActionTokoList'
import TransferForAllSalesmanActionTokoList from './TransferForAllSalesmanActionTokoList'
import TransferSalesmanActionTokoList from './TransferSalesmanActionTokoList'
import Form from 'vform'
import { pickBy, isEmpty } from 'lodash'
import localStorage from 'store'
import {
    hasRoles,
    hasColumnRoles,
    ROLE_ADMIN_BK,
    ROLE_TSO,
    ROLE_ASM,
    ROLE_TIM_CRM,
    ROLE_DISTRIBUTOR,
    ROLE_HELPDESK,
    ROLE_CRM_HELPDESK_CUSTOMER_CARE,
} from '@/helpers'

export default defineComponent({
    components: {
        FilterATSalesmanCustomer,
        FilterSalesmanToko,
        FilterATSalesmanDistributorSalesman,
        FilterArea,
        FilterUserByVendorMapping,
        DownloadExcel,
        UploadTokoList,
        SwitchMappingSalesmanActionTokoList,
        TransferForAllSalesmanActionTokoList,
        TransferSalesmanActionTokoList,
    },
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
            }),
        },
    },
    emits: ['update:visible'],
    setup(props, { emit }) {
        const errorMessage = ref()
        const formRef = ref();
        const user = computed(() => localStorage.get('profile'))

        const form = reactive(new Form({
            salesman_id: props.item.id,
            distributor_id: null,
            tso_id: null,
            customer_id: [],
        }))

        const state = reactive({
            columns: hasColumnRoles([
                {
                    title: 'Kode Toko',
                    dataIndex: 'customer_code',
                },
                {
                    title: 'Nama Toko',
                    dataIndex: 'customer_name',
                },
                {
                    title: 'Kode Dist',
                    dataIndex: 'distributor_code',
                },
                {
                    title: 'Nama Distributor',
                    dataIndex: 'distributor_name',
                },
                {
                    title: 'Area',
                    dataIndex: 'area',
                },
                {
                    title: 'Action',
                    dataIndex: 'action',
                    slots: { customRender: 'action' },
                },
            ], {
                action: [ROLE_ADMIN_BK, ROLE_TSO, ROLE_TIM_CRM, ROLE_CRM_HELPDESK_CUSTOMER_CARE, ROLE_HELPDESK, ROLE_DISTRIBUTOR, ROLE_ASM],
            }),
            endpoint: {
                current: `/api/users-salesman/customers/${props.item.id}`,
                current_distributor: `/api/users-salesman/by-distributor/customers`,
                approve: '/api/users-salesman/customer/request-approve',
                reject: '/api/users-salesman/customer/request-reject',
            },
            errors: [],
            data: [],
            toko: [],
            area: [],
            meta: {
                per_page: 10,
                page: 1,
                total: 0,
            },
            isFetching: false,
            params: {
                q: '',
                toko: [],
                area: [],
                page: 1,
                "per-page": 10,
            },
            isForm: false,
            rules: {
                distributor_id: [
                    {
                        required: true,
                        message: "Distributor tidak boleh kosong!",
                    },
                ],
                customer_id: [
                    {
                        required: true,
                        message: "Toko tidak boleh kosong!",
                    },
                ],
                tso_id: [
                    {
                        required: true,
                        message: "TSO tidak boleh kosong!",
                    },
                ],
            },
            vendor_id: null,
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const handleTableChange = (page, filters, sorter) => {
            state.params.page = page.current
            state.params["per-page"] = page.pageSize

            fetchDataList()
        }

        const handleOk = async () => {
            state.errors = []

            // validation form
            await formRef.value.validate()
                .catch(() => { });

            let endpoint = hasRoles([ROLE_DISTRIBUTOR])
                ? state.endpoint.current_distributor
                : state.endpoint.current

            // exceprt role distributor
            if (!hasRoles([ROLE_DISTRIBUTOR])) {
                let customers = []
                form.customer_id.forEach(item => {
                    customers.push({
                        vendor_id: form.distributor_id,
                        customer_id: item,
                    })
                })
                form.customers = customers
            }

            form.post(endpoint)
                .then(({ data }) => {
                    if (data === undefined) {
                        errorMessage.value = `Kode error 500, No response from server`
                        return
                    }

                    if (data.success && state.isForm) {
                        form.reset()
                        formRef.value.resetFields()
                        state.isForm = false
                        fetchDataList()
                        message.success(data.message)
                    }
                })
                .catch(async error => {
                    errorMessage.value = null
                    if (error.response) {
                        const { status, statusText, data } = error.response

                        if (status === 400) {
                            data.message.forEach(item => {
                                state.errors.push({
                                    message: item,
                                    status: data.status,
                                })
                            })
                        }

                        if (status === 500) {
                            const message = data.message
                            if (Array.isArray(message)) {
                                state.errors = message
                            } else {
                                errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                            }
                        }
                    }
                })

        }

        // fetch list data
        const fetchDataList = () => {
            state.isFetching = true

            apiClient
                .get(state.endpoint.current, {
                    params: pickBy(state.params),
                })
                .then(({ data }) => {
                    const { items, _meta } = data

                    items.forEach((item) => {
                        item.isDelete = false
                    })

                    state.data = items
                    state.meta.page = _meta.currentPage
                    state.meta.per_page = _meta.perPage
                    state.meta.total = _meta.totalCount
                })
                .finally(() => {
                    state.isFetching = false
                })
        }

        // btn delete
        const btnDelete = (record) => {
            Modal.confirm({
                title: 'Konfirmasi Hapus',
                content: 'Apakah anda ingin hapus item tersebut?',
                onOk() {
                    record.isDelete = true

                    apiClient
                        .post(`/api/users-salesman/customers/${props.item.id}/delete`, {
                            id: record.id,
                        })
                        .then(({ data }) => {
                            fetchDataList()
                            message.success(data.message)
                        })
                        .catch(e => message.error('Gagal menghapus!'))
                        .finally(() => {
                            record.isDelete = false
                        })
                },
                onCancel() { },
            })
        }

        // handle upload
        const visibleUploadModal = ref(false);
        const visibleUploadItemModal = ref(null);

        const btnUpload = () => {
            visibleUploadModal.value = true
            visibleUploadItemModal.value = props.item
        }

        // handle form
        const visibleFormSwitchSalesmanModal = ref(false);
        const visibleFormSwitchSalesmanItemModal = ref(null);
        const visibleFormTransferForAllSalesmanModal = ref(false);
        const visibleFormTransferForAllSalesmanItemModal = ref(null);
        const visibleFormTransferSalesmanModal = ref(false);
        const visibleFormTransferSalesmanItemModal = ref(null);

        const btnFormSwitchSalesman = () => {
            console.log('Switch clicked: >> ', visibleFormSwitchSalesmanModal.value)

            visibleFormSwitchSalesmanModal.value = true
            visibleFormSwitchSalesmanItemModal.value = {
                ...props.item,
            }

            console.log('Switch clicked: >> ', visibleFormSwitchSalesmanModal.value)
        }

        const btnFormTransferForAllSalesman = () => {
            console.log('Transfer clicked: >> ', visibleFormTransferForAllSalesmanModal.value)

            visibleFormTransferForAllSalesmanModal.value = true
            visibleFormTransferForAllSalesmanItemModal.value = {
                ...props.item,
            }

            console.log('Transfer clicked: >> ', visibleFormTransferForAllSalesmanModal.value)
        }

        const btnFormTransferSalesman = () => {
            visibleFormTransferSalesmanModal.value = true
            visibleFormTransferSalesmanItemModal.value = {
                ...props.item,
            }
        }

        onMounted(() => {
            if (hasRoles([ROLE_DISTRIBUTOR])) {
                state.vendor_id = user.value.vendor_id
            }

            fetchDataList()
        })

        return {
            fetchDataList,
            state,
            formRef,
            form,
            handleModalCancel,
            handleTableChange,
            handleOk,
            btnDelete,
            errorMessage,
            visibleUploadModal,
            visibleUploadItemModal,
            btnUpload,
            btnFormSwitchSalesman,
            btnFormTransferForAllSalesman,
            btnFormTransferSalesman,
            visibleFormSwitchSalesmanModal,
            visibleFormSwitchSalesmanItemModal,
            visibleFormTransferForAllSalesmanModal,
            visibleFormTransferForAllSalesmanItemModal,
            visibleFormTransferSalesmanModal,
            visibleFormTransferSalesmanItemModal,
            // lodash
            isEmpty,
            // only variable role
            hasRoles,
            hasColumnRoles,
            ROLE_ADMIN_BK,
            ROLE_TSO,
            ROLE_ASM,
            ROLE_TIM_CRM,
            ROLE_DISTRIBUTOR,
            ROLE_HELPDESK,
            ROLE_CRM_HELPDESK_CUSTOMER_CARE,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
